// extracted by mini-css-extract-plugin
module.exports = {"title":"ArticleFeedAlternate_title__8Hojk","inner":"ArticleFeedAlternate_inner__vuBk9","image":"ArticleFeedAlternate_image__0um2s"};